module.exports = __webpack_public_path__ + "static/img/bac1.b06e4ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/bac1.png
// module id = 99Ru
// module chunks = 2